module.exports = __webpack_public_path__ + "img/statusPanel-2.d0e51b00.png";